import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useStore, useContext } from '@nuxtjs/composition-api';
import ShareLinks from '~/components/resource/ShareLinks.vue';
import { State } from '@/store';

interface Props {
  resourceId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionButtons',
  props: {
    resourceId: null
  },
  setup(__props: any) {

const props = __props as {
  resourceId: number;
};


const $store = useStore<State>();
const isAuthenticated = computed(() => $store.getters.isAuthenticated);
const resourceStats = computed(() => $store.getters.resourceStats);
const userFolders = computed(() => $store.getters.userFolders);
const resource = computed(() => $store.getters.resource);
const loadingBookmark = ref(false);
const loadingLike = ref(false);
const { $intercom, $intercomIdentify, $mzAnalyticsApi } = useContext();

const toggleUpgradeModal = (show: boolean) => {
  $store.dispatch('toggleUpgradeModal', show);
};
const toggleSelectFolderModal = (show: boolean, id: number) => {
  $store.dispatch('toggleSelectFolderModal', { show, id });
};
const eventResourceAction = (eventAction: string) => {
  if (!resource.value.event_params) {
    return;
  }
  const eventType = resource.value.event_params.Resource_Type_Name ? 'Resource' : 'Content';
  const eventParams =
    eventAction === 'Saved'
      ? { ...resource.value.event_params, Save_Type_Name: 'Bookmark' }
      : resource.value.event_params;
  let pageType = resource.value.type
    .trim()
    .replace(/[\s-]+/g, '_')
    .toLowerCase();
  let productAreas = '';
  if (pageType === 'teaching_resource') {
    pageType = 'resource';
    productAreas = 'resources';
  } else if (pageType === 'unit_plan') {
    productAreas = 'unit_plan';
  } else if (pageType === 'blog') {
    productAreas = 'content';
  } else if (pageType === 'podcast') {
    productAreas = 'content';
  } else if (pageType === 'resource_pack') {
    pageType = 'pack';
    productAreas = 'pack';
  } else if (pageType === 'widget') {
    productAreas = 'widget';
  } else if (pageType === 'lesson_plan') {
    productAreas = 'lesson_plan';
  }
  const analyticsName = `${pageType}.bookmark`;

  $mzAnalyticsApi({
    event: 'click',
    name: analyticsName,
    productArea: productAreas,
    entityType: pageType,
    entityId: resource.value.id,
  });
  if (resource.value.event_params_intercom) {
    const metadata = resource.value.event_params_intercom;
    if (typeof $intercom !== 'undefined') {
      $intercom.trackEvent('Reaction Added', metadata);
      $intercomIdentify();
    }
  }
};
const toggleLikeBookmark = async (action: string, isActive: boolean) => {
  if (!isAuthenticated.value) {
    toggleUpgradeModal(true);
    return;
  }
  const params = {
    action,
    id: props.resourceId,
    type: resource.value.type,
    active: isActive || false,
  };
  let message = '';
  if (action === 'bookmark') {
    loadingBookmark.value = true;
    message = 'Added to bookmarks';
  } else {
    loadingLike.value = true;
    message = 'Liked this resource';
  }
  try {
    await $store.dispatch('toggleLikeBookmark', params);
    if (!isActive) {
      $store.dispatch('setToast', {
        content: message,
      });
      eventResourceAction(action === 'bookmark' ? 'Saved' : 'Liked');
    }
  } catch (err: Error | any) {
    console.error(err);
  } finally {
    loadingBookmark.value = false;
    loadingLike.value = false;
  }
};

const inFolders = computed(() => {
  return userFolders.value.filter((c: { items: any[] }) => {
    if (c.items) {
      return c.items.find(
        (item: { resource: { id: number } }) =>
          item.resource && item.resource.id === resource.value.id
      );
    }

    return false;
  }).length;
});

return { __sfc: true,props, $store, isAuthenticated, resourceStats, userFolders, resource, loadingBookmark, loadingLike, $intercom, $intercomIdentify, $mzAnalyticsApi, toggleUpgradeModal, toggleSelectFolderModal, eventResourceAction, toggleLikeBookmark, inFolders, ShareLinks }
}

})